<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.54303 4.26721H12.9462C14.537 4.26721 15.8266 5.55683 15.8266 7.14766V7.14766C15.8266 8.73849 14.537 10.0281 12.9462 10.0281H7.39621C5.82044 10.0281 4.54303 11.3055 4.54303 12.8813V12.8813C4.54303 14.4571 5.82044 15.7345 7.39622 15.7345H15.8266" stroke="currentColor" stroke-width="1.25"/>
        <circle cx="4.27209" cy="4.26666" r="1.98333" fill="currentColor"/>
        <circle cx="15.7279" cy="15.7315" r="1.98333" fill="currentColor"/>
    </svg>
</template>
